module.exports = __webpack_public_path__ + "img/B560.a8150e1a.jpg";